// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1vMA5","alertIcon":"ConfirmModal_alertIcon__3qJNi"};